import qs from 'qs';

export const TOKEN_NAME = 'token';
export const TEMPORARY_TOKEN_NAME = 'temporaryToken';

const getQueryParams = (search = window.location.search) =>
  qs.parse(search, { ignoreQueryPrefix: true });
const getQueryParamValue = (name) => getQueryParams()[name];
const stringifyQueryParams = (params) => qs.stringify(params, { addQueryPrefix: true });
const addQueryParamsToPath = (params) =>
  `${window.location.pathname}${stringifyQueryParams(params)}`;

const getTokenAsQueryParam = () => {
  const tokenQueryParam = {};
  tokenQueryParam[TOKEN_NAME] = getQueryParamValue(TOKEN_NAME);
  tokenQueryParam[TEMPORARY_TOKEN_NAME] = getQueryParamValue(TEMPORARY_TOKEN_NAME);
  return { ...tokenQueryParam };
};

export const modifyHistory = (history) => {
  const createSearchWithToken = (search) =>
    search ? { ...getQueryParams(search), ...getTokenAsQueryParam() } : getTokenAsQueryParam();

  history.pushWithToken = (params) => {
    if (typeof params === 'string') {
      history.push({
        pathname: params,
        search: stringifyQueryParams(getTokenAsQueryParam()),
      });
    } else {
      history.push({
        ...params,
        search: stringifyQueryParams(createSearchWithToken(params.search)),
      });
    }
  };

  history.replaceWithToken = (params) => {
    history.replace({
      ...params,
      search: stringifyQueryParams(createSearchWithToken(params.search)),
    });
  };
  return history;
};

export const getTokenFromStorage = (name = TOKEN_NAME) => getQueryParamValue(name);
export const setTokenToStorage = (token, name = TOKEN_NAME) => {
  const tokenQueryParam = {};
  tokenQueryParam[name] = token;

  const newParams = {
    ...getQueryParams(),
    ...tokenQueryParam,
  };
  const newUrl = addQueryParamsToPath(newParams);
  window.history.replaceState(
    window.history.state,
    null,
    window.location.hash ? `${newUrl}${window.location.hash}` : newUrl,
  );
};
export const removeTokenFromStorage = (name = TOKEN_NAME) => {
  const queryParams = getQueryParams();
  queryParams[name] = undefined;

  const newUrl = addQueryParamsToPath(queryParams);
  window.history.replaceState(null, null, newUrl);
};

export const restoreOriginalTokenFromTemporary = () => {
  const originalToken = getTokenFromStorage(TEMPORARY_TOKEN_NAME);
  if (originalToken) {
    const queryParams = getQueryParams();
    queryParams[TEMPORARY_TOKEN_NAME] = undefined;
    queryParams[TOKEN_NAME] = originalToken;
    const newUrl = addQueryParamsToPath(queryParams);
    window.history.replaceState(null, null, newUrl);
  }
};
